export default __webpack_public_path__ + "static/media/dog1.aa7ce1be.jpg";